const {__, _x, _n, _nx} = wp.i18n;

//Bootstrap component list: Alert, BaseComponent, Button, Carousel, Collapse, Dropdown, Modal, Offcanvas, Popover, ScrollSpy, Tab, Tooltip, Toast
import {Collapse} from 'bootstrap';

//require('./utilities/class_enlarge.js');
//require('./utilities/class_count.js');
require('./utilities/pdw_mobile_menu.js');
require('./utilities/pdw_drilldown_menu.js');
//require('./utilities/pdw_modal_search.js');
require('./utilities/pdw_carousel.js');
// require('./utilities/splide_autoscroll');
require('./utilities/pdw_hide_link.js');
require('./utilities/pdw_scrolled.js');
require('./utilities/pdw_lightbox.js');
require('./utilities/pdw_aos.js');
require('./utilities/gsap_shape.js');
//require('./utilities/pseudo_element_header');

// require('./utilities/pdw_header_ready.js');

//require('./utilities/pdw_woocommerce.js');

